module.exports = "/_next/static/images/Group-6167-f74288e199d69bb5be554f60f9ad39c8.svg";